var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect } from 'react';
import { useLocalStorage } from '../useLocalStorage';
export const useOnFilespaceUpgrade = ({ filespaceList, localStorageKey, onFinishUpgrade, onStartUpgrade, }) => {
    _react_refresh_temp_1();
    const { removeValue: removeRegisteredFilespaces, setValue: setRegisteredFilespaces, value: registeredFilespaces = [], } = useLocalStorage(localStorageKey || '');
    useEffect(() => {
        if (!localStorageKey) {
            return;
        }
        let updatedRegister = [...registeredFilespaces];
        let shouldRegister = false;
        filespaceList.forEach((filespace) => {
            const oldFilespace = registeredFilespaces.find((fs) => fs.workspaceId === filespace.workspaceId &&
                fs.name === filespace.name);
            if (filespace.isMigrating && !oldFilespace) {
                updatedRegister.push(filespace);
                shouldRegister = true;
                onStartUpgrade?.({
                    filespace,
                });
            }
            if (!filespace.isMigrating && oldFilespace) {
                const isUpgradeSuccessful = filespace.id !== oldFilespace.id;
                updatedRegister = updatedRegister.filter((fs) => !(fs.name === oldFilespace.name &&
                    fs.workspaceId === oldFilespace.workspaceId));
                shouldRegister = true;
                onFinishUpgrade?.({
                    isUpgradeSuccessful,
                    oldFilespace,
                    newFilespace: filespace,
                });
            }
        });
        if (shouldRegister) {
            if (updatedRegister.length === 0) {
                removeRegisteredFilespaces();
            }
            else {
                setRegisteredFilespaces(updatedRegister);
            }
        }
    }, [
        filespaceList,
        localStorageKey,
        onStartUpgrade,
        onFinishUpgrade,
        registeredFilespaces,
        removeRegisteredFilespaces,
        setRegisteredFilespaces,
    ]);
};
_react_refresh_temp_1(useOnFilespaceUpgrade, "1Exp5nmLXYio6i/6VmLteXzX/ww=", false, () => [useLocalStorage]);
